module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navbar p-0 navbar-light fixed-top"
  }, [_c('div', {
    staticClass: "justify-content-between flex-nowrap flex-row"
  }, [_c('div', {
    staticClass: "user-name-area-wrap container-fuild w-100 text-danger"
  }, [_c('div', {
    staticClass: "user-name-area navbar-brand text-danger w-75"
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[93][1]",
      "replaceData": {
        user_name: _vm.userName
      },
      "isHtml": true
    }
  })], 1), _vm._v(" "), _c('header-right-menu-mobile', {
    attrs: {
      "iconSizeClass": "fa-3x",
      "headerHeight": "50"
    },
    on: {
      "logout": _vm.logout
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row nav-cell-area no-gutters"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('router-link', {
    staticClass: "nav-cell w-100 h-100",
    attrs: {
      "tag": "div",
      "to": {
        name: 'mypage::event'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-clone",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('router-link', {
    staticClass: "nav-cell w-100 h-100 d-inline-block",
    attrs: {
      "tag": "div",
      "to": {
        name: 'mypage::orderer_info'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-address-book",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('router-link', {
    staticClass: "nav-cell w-100 h-100 d-inline-block",
    attrs: {
      "tag": "div",
      "to": {
        name: 'mypage::child_info'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-child",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('router-link', {
    staticClass: "nav-cell w-100 h-100 d-inline-block",
    attrs: {
      "tag": "div",
      "to": {
        name: 'mypage::order'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-file-text-o",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1003231d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/global/partials/LoggedInHeader/MobileHeader.vue
// module id = 671
// module chunks = 0